import React from "react";
import Tooltip from "../Tooltip/Tooltip";
import { ReactComponent as InformationIcon } from "../../../assets/icons/information.svg";
// import "../../../css/DesignSystem/Inputs/InputField.css";

const NewInputField = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  required = false,
  helperText,
  tooltip,
  error,
  disabled = false,
  readOnly = false,
  type = "text",
  min,
  step,
  "aria-label": ariaLabel,
}) => {
  return (
    <div className="AnnouncementInputField">
      {label && (
        <label
          htmlFor={id}
          className="AnnouncementInputField__Label FP_Content text-black"
        >
          <span>{label}</span>{" "}
          {required && (
            <span className="FP_Content_Semibold text-error">*</span>
          )}
          {tooltip && (
            <Tooltip content={tooltip} position="top">
              <InformationIcon
                className="ds-input-tooltip-icon"
                aria-label={`${label} help`}
              />
            </Tooltip>
          )}
        </label>
      )}

      {helperText && (
        <p className="AnnouncementInputField__Helper FP_Content text-black">
          {helperText}
        </p>
      )}

      <input
        id={id}
        aria-label={ariaLabel}
        type={type}
        min={min}
        step={step}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        className={`FP_Content fp-form-input text-black ${error ? "fp-form-input--error" : ""}`}
      />

      {error && <p className="AnnouncementInputField__Error">{error}</p>}
    </div>
  );
};

export default NewInputField;
